module.exports = __webpack_public_path__ + "img/logo-unc.5256c34b.png";